"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var ValidUserRegistration = require("./user-validRegistration");
var InvalidTokenUserRegistration = require("./user-invalidTokenRegistration");
var MAIN_TEMPLATE = require("../html/UserRegistration.html");
var INVALID_TOKEN_REG_TEMPLATE = require("../html/InvalidUserRegistration.html");
var VALID_REG_TEMPLATE = require("../html/ValidUserRegistration.html");
var RECIEVE_CODE_TEMPLATE = "";
var ENTER_TOKEN_TEMPLATE = "";
var templatesText = require("../json/TemplatesText.json");

require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");

var OPTIONAL_FIELDS = [{
    selector: ".ie789-only",
    configKey: "showLabels"
}];

function UimUserRegistrationWidget(params) {
    common.validateParams(params);
    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;
    this.apigeeKey = params.configuration.apigeeKey;
    this.token = params.configuration.token;
    this.mobilePlcaehoder = params.configuration.mobilePlcaehoder;
    this.passwordPlaceholder = params.configuration.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.configuration.passwordConfirmationPlaceholder;
    this.environment = params.configuration.environment;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/pre-registration-request';
    this.element = params.element;
}

UimUserRegistrationWidget.prototype.init = function () {
    var self = this,
        language = ["en"],
        handleBarTemplates = window.morningstar.uim.templates,
        // Select the widget data using language locale
        widgetText = templatesText[language];
    RECIEVE_CODE_TEMPLATE = handleBarTemplates.ReceiveMfaCode(widgetText.receiveMFA);
    ENTER_TOKEN_TEMPLATE = handleBarTemplates.EnterMfaToken(widgetText.enterMFA);

    this.element.append(MAIN_TEMPLATE);
    this.validUserRegistrationParent = this.element.find(".uim-valid-registration");
    this.validUserRegistrationParent.append(VALID_REG_TEMPLATE);
    common.showElement(this.validUserRegistrationParent.find("div#showPasswordRequirements"));
    common.showElement(this.validUserRegistrationParent.find("div#mobileNumberShow"));

    // default ValidUserRegistration to be hidden
    this.validUserRegistrationParent.hide();

    this.invalidRegTokenParent = this.element.find(".uim-invalid-registration");
    this.invalidRegTokenParent.append(INVALID_TOKEN_REG_TEMPLATE);

    // default invalid token page to be hidden
    this.invalidRegTokenParent.hide();

    this.mfaParent = this.element.find(".uim-mfa");
    this.mfaParent.append(RECIEVE_CODE_TEMPLATE);
    this.mfaParent.append(ENTER_TOKEN_TEMPLATE);
    this.receiveLocaleWidget = widgetText.receiveMFA;
    this.enterLocaleWidget = widgetText.enterMFA;

    // default MFA to be hidden
    this.mfaParent.hide();

    var requestId = uuid();

    for (var index = 0; index < OPTIONAL_FIELDS.length; index++) {
        var field = OPTIONAL_FIELDS[index];

        var showField = this[field.configKey];

        if (showField === false || showField === undefined) {
            common.hideElement(this.element.find(field.selector));
        }
    }

    $.ajax({
        method: "GET",
        url: this.apiUrl + "/" + this.token,
        headers : {
            ApiKey : this.apigeeKey,
            "X-API-RequestId": requestId
        },
        dataType: 'json',
        contentType: "application/json"
    }).success(function(data, status) {
        self.successCallback(data, status);
        self.validUserRegistrationParent.show();
        self.invalidRegTokenParent.hide();

        var emailAddress = data.data.attributes.emailAddress;
        var mobile = data.data.attributes.regMobileNumber;
        var mfaEnforcedValue = data.data.attributes.regMfaEnforced;
        var redirectURL = data.data.attributes.regRedirectURL;

        var validUserRegistration = new ValidUserRegistration({
            validUserWidgetInstance: self,
            email: emailAddress,
            token:self.token,
            environment: self.environment,
            countryCode: self.countryCode,
            apigeeKey: self.apigeeKey,
            passwordPlaceholder: self.passwordPlaceholder,
            confirmPasswordPlaceholder: self.passwordConfirmationPlaceholder,
            mobilePlcaehoder: self.mobilePlcaehoder,
            mobileNumber: mobile,
            redirectURL: redirectURL,
            mfaEnforced: mfaEnforcedValue,
            mfaParent: self.mfaParent,
            receiveLocaleWidget: self.receiveLocaleWidget,
            enterLocaleWidget: self.enterLocaleWidget
        });
        return validUserRegistration.init(requestId);

    }).error(function (response, status) {
        self.errorCallback(new Error("Expired preregistration link"), response.status);
        self.validUserRegistrationParent.hide();
        self.invalidRegTokenParent.show();
        var invalidTokenUserRegistration = new InvalidTokenUserRegistration({
            validUserWidgetInstance: self,
            environment: self.environment,
            apigeeKey: self.apigeeKey
        });
        return invalidTokenUserRegistration.init(requestId);
    });
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimUserRegistrationWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/user-registration.js
// module id = 37
// module chunks = 0